var Alert = {};

(function ( $ ) {
    var target = $( '#js-alert' ),
        image = target.find( '#js-alert-image' ),
        title = target.find( '#js-alert-title' ),
        text = target.find( '#js-alert-text' ),
        button = target.find( '#js-alert-button' ),
        messageContainer = target.find( '#js-alert-message-container' );

    Alert.show = function ( type, header, message ) {
        if ( target.length === 0 ) {
            return;
        }

        var buttonClass = button.data( 'classDefault' ),
            imageSource = '',
            messageContainerClass = '';

        switch ( type ) {
            case 'success':
                buttonClass = button.data( 'classSpecial' );
                imageSource = image.data( 'iconSuccess' );
                messageContainerClass = messageContainer.data( 'classSuccess' );
                break;
            case 'warning':
                imageSource = image.data( 'iconWarning' );
                messageContainerClass = messageContainer.data( 'classWarning' );
                break;
            case 'danger':
                imageSource = image.data( 'iconDanger' );
                messageContainerClass = messageContainer.data( 'classDanger' );
                break;
            default:
                return;
        }

        image.attr( 'src', imageSource );

        title.html( header );
        title.attr( 'class', title.data('class-'+ type) );

        text.html( message );
        text.attr( 'class', text.data('class-'+ type) );

        button.attr( 'class', buttonClass );

        messageContainer.attr( 'class', 'modal-body p-0 ' + messageContainerClass );

        target.modal( 'show' );
    };

    $( function () {
        if ( target.length === 0 ) {
            return;
        }

        button.click( function () {
            target.modal( 'hide' );
        } );
    } )

})( jQuery );

window.Alert = Alert;

module.exports = Alert;


// WEBPACK FOOTER //
// ./scripts/components/alert.js